import { API, apiRequest } from "../api";
import { GetReviewTreeReq, GetReviewTreeRsp } from "./review";
import {
    GetAvgScoreReq,
    GetAvgScoreRsp,
    GetExerciseReq,
    GetExerciseRsp,
    GetHomeReq,
    GetHomeRsp,
} from "./summary";

const apiGetHomeSummary: API<GetHomeReq, GetHomeRsp> = {
    url: "/api/summary/get",
};

export function methodGetHomeSummary(dispatch: any, req: GetHomeReq) {
    return apiRequest({ api: apiGetHomeSummary, req, dispatch });
}

const apiGetExerciseSummary: API<GetExerciseReq, GetExerciseRsp> = {
    url: "/api/summary/get_exercise",
};

export function methodGetExerciseSummary(dispatch: any, req: GetExerciseReq) {
    return apiRequest({ api: apiGetExerciseSummary, req, dispatch });
}

const apiGetAvgScore: API<GetAvgScoreReq, GetAvgScoreRsp> = {
    url: "/api/summary/get_avg_score",
};

export function methodGetAvgScore(dispatch: any, req: GetAvgScoreReq) {
    return apiRequest({ api: apiGetAvgScore, req, dispatch });
}

const apiGetReviewTree: API<GetReviewTreeReq, GetReviewTreeRsp> = {
    url: "/api/review/get_tree",
};

export function methodGetReviewTree(dispatch: any, req: GetReviewTreeReq) {
    return apiRequest({ api: apiGetReviewTree, req, dispatch });
}
